import type { ProfileAccount, ProfileEmployer } from '../services/api';

export type ProfileIdentityItem = {
  label: string;
  account: ProfileAccount | null;
};

type ProfileIdentityInput = {
  profession: string | null;
  employer: ProfileEmployer | null;
  university: string | null;
  universityAccount: ProfileAccount | null;
};

// Kimlik alanlarının tümü aynı satırda, yalnız mevcut değerlerin arasında
// ayıraç üretilerek gösterilir. @ yalnız dokunulabilir bir nosubject hesabına
// ayrılmıştır; veritabanındaki kurum adı bağlantı yoksa düz metin kalır.
export function buildProfileIdentityItems({
  profession,
  employer,
  university,
  universityAccount,
}: ProfileIdentityInput): ProfileIdentityItem[] {
  const items: ProfileIdentityItem[] = [];
  if (profession) items.push({ label: profession, account: null });
  if (employer) items.push({ label: `@${employer.username}`, account: employer });
  if (universityAccount) {
    items.push({ label: `@${universityAccount.username}`, account: universityAccount });
  } else if (university) {
    items.push({ label: university, account: null });
  }
  return items;
}
